import React from 'react';
import { useLanguage } from '../helpers/language-context';

const LanguageSwitcher = ({ scrolling }) => {
  const { language, changeLanguage, languages } = useLanguage();

  const toggleLanguage = () => {
    changeLanguage(
      language === languages.ENGLISH ? languages.MALAY : languages.ENGLISH
    );
  };

  return (
    <button 
      onClick={toggleLanguage}
      className={`${scrolling ? 'bg-[#28357B] bg-opacity-10 text-gray-700 hover:bg-opacity-20 hover:text-[#28357B]' : 'bg-gray-200 bg-opacity-20 text-white hover:bg-opacity-30'} px-2 py-1 my-[2px] text-xs font-medium rounded`}
    >
      {language === languages.ENGLISH ? 'BM' : 'EN'}
    </button>
  );
};

export default LanguageSwitcher;